import { render, staticRenderFns } from "./DealByMakePod.vue?vue&type=template&id=63076bc3&scoped=true"
import script from "./DealByMakePod.vue?vue&type=script&lang=js"
export * from "./DealByMakePod.vue?vue&type=script&lang=js"
import "./DealByMakePod.vue?vue&type=style&index=0&id=63076bc3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63076bc3",
  null
  
)

export default component.exports